import { useRef, useState } from "react";

import Webcam from "react-webcam";

import { base64URLToFile } from "../../../../utils/base64ToFile";

import styles from "./styles.module.scss";

const CameraModal = ({ onClose, onCapture , setFiles , files }) => {
  const webcamRef = useRef(null);
  const [capturedImage, setCapturedImage] = useState(null);

  const handleCapture = () => {
    const imageSrc = webcamRef.current?.getScreenshot();
    if (imageSrc) {
      setCapturedImage(imageSrc);
      const fileObject = base64URLToFile(imageSrc,'image.jpeg');

      setFiles([fileObject])
    }
  };

  const handleRetake = () => {
    setCapturedImage(null);
  };

  const handleConfirm = () => {
    if (capturedImage && onCapture) {
      onCapture(capturedImage);
    }
    onClose();
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2 className={styles.title}>Capture Photo</h2>

        <div className={styles.cameraContainer}>
          {!capturedImage ? (
            <Webcam
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              className={styles.webcam}
              videoConstraints={{
                facingMode: "environment",
              }}
            />
          ) : (
            <img src={capturedImage} alt="Captured" className={styles.preview} />
          )}
        </div>

        <div className={styles.actions}>
          {!capturedImage ? (
            <>
              <button className={styles.captureBtn} onClick={handleCapture}>
                Capture
              </button>
              <button className={styles.cancelBtn} onClick={onClose}>
                Cancel
              </button>
            </>
          ) : (
            <>
              <button className={styles.retakeBtn} onClick={handleRetake}>
                Retake
              </button>
              <button className={styles.submitBtn} onClick={handleConfirm}>
                Use Photo
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CameraModal;